<main>
  <div class="as-content-download-app">
    <div class="as-content-info">
      <div class="as-container-image-alsuper" (click)="goBack()">
        <img
          width="227"
          height="54"
          class="as-pointer as-imagen-alsuper"
          ngSrc="assets/images/alsuper.png"
        />
      </div>
      <p class="as-title-download as-font-w-700 as-text-download">
        {{ 'DOWNLOAD-APPS.download' | translate }}
      </p>
      <p class="as-text-from-iphone as-text-exp">
        {{ 'DOWNLOAD-APPS.exp' | translate }}
      </p>
      <div class="as-content-image-download as-content-display-nono-responsive">
        <a [href]="appStoreUrl" target="_blank">
          <div class="as-images-download-store as-margin-left as-pointer">
            <p class="as-text-name-store">
              {{ 'DOWNLOAD-APPS.fromIphone' | translate }}
            </p>
            <img
              width="148"
              height="48"
              class="as-pointer as-app-store"
              ngSrc="assets/images/app-store.png"
            />
          </div>
        </a>
        <a [href]="googlePlayUrl" target="_blank">
          <div class="as-images-download-store as-pointer">
            <p class="as-text-name-store">
              {{ 'DOWNLOAD-APPS.fromAndroid' | translate }}
            </p>
            <img
              width="148"
              height="48"
              class="as-pointer as-google-play"
              ngSrc="assets/images/google-play.png"
            />
          </div>
        </a>
      </div>
    </div>
    <div class="as-images-phones">
      <img
        width="366"
        height="405"
        class="as-size-image-phones"
        ngSrc="assets/images/telefonos-landing-ne.webp"
      />
    </div>
  </div>
  <div class="as-content-image-download as-display-none-desktop">
    <div class="as-images-download-store as-margin-left">
      <p class="as-text-name-store">
        {{ 'DOWNLOAD-APPS.fromIphone' | translate }}
      </p>
      <a [href]="appStoreUrl" target="_blank">
        <img
          width="148"
          height="48"
          class="as-pointer as-app-store"
          ngSrc="assets/images/app-store.png"
        />
      </a>
    </div>
    <div class="as-images-download-store">
      <p class="as-text-name-store">
        {{ 'DOWNLOAD-APPS.fromAndroid' | translate }}
      </p>
      <a [href]="googlePlayUrl" target="_blank">
        <img
          width="148"
          height="48"
          class="as-pointer as-google-play"
          ngSrc="assets/images/google-play.png"
        />
      </a>
    </div>
  </div>
  <div class="as-profit-container">
    <p class="as-title-profit as-font-w-700">
      {{ 'DOWNLOAD-APPS.titleProfit' | translate }}
    </p>
    <div class="as-flex-direction as-flex-wrap-reverse">
      <img
        width="357"
        height="594"
        class="as-imagen-iphone-track"
        ngSrc="assets/images/iPhone-track.png"
      />
      <div class="as-content-info-tracking">
        <p class="as-continue-tracking as-font-w-700 as-font-red-warn">
          {{ 'DOWNLOAD-APPS.continuTracking' | translate }}
        </p>
        <p class="as-font-w-700 as-text-verify">
          {{ 'DOWNLOAD-APPS.verify' | translate }}
        </p>
      </div>
    </div>
  </div>
  <div class="as-flex-direction as-justify-content as-flex-wrap">
    <div class="as-content-info-tracking">
      <p class="as-font-w-700 as-continue-tracking as-font-red-warn">
        {{ 'DOWNLOAD-APPS.titleFavorites' | translate }}
      </p>
      <p class="as-font-w-700 as-text-verify">
        {{ 'DOWNLOAD-APPS.scanCode' | translate }}
      </p>
    </div>
    <img
      width="447"
      height="531"
      class="as-image-size-add-products"
      ngSrc="assets/images/iphone-favorites.png"
      priority
    />
  </div>
  <div class="as-flex-direction as-margin-left-contact as-flex-wrap-reverse">
    <img
      width="294"
      height="584"
      class="as-imagen-iphone-contact"
      ngSrc="assets/images/iPhone-contact.png"
    />
    <div class="as-content-info-tracking">
      <p class="as-font-w-700 as-continue-tracking as-font-red-warn">
        {{ 'DOWNLOAD-APPS.titleContac' | translate }}
      </p>
      <p class="as-font-w-700 as-text-verify">
        {{ 'DOWNLOAD-APPS.addNewProduct' | translate }}
      </p>
    </div>
  </div>
  <div class="as-content-shop-way">
    <p
      class="as-font-w-700 as-continue-tracking as-font-red-warn as-text-align-center"
    >
      {{ 'DOWNLOAD-APPS.shopWay' | translate }}
    </p>
  </div>
  <div class="frame-container">
    <iframe
      class="as-video-frame"
      src="https://www.youtube.com/embed/Q--iItHtTz0?si=sNLfwF-v2M3N2EP_"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
  <div class="as-flex-direction as-content-download-app-footer">
    <img
      width="189"
      height="189"
      class="as-imagen-app-icon-alsuper"
      ngSrc="assets/images/AppIcon_Alsuper_Square.png"
    />
    <div class="as-content-info-app">
      <p class="as-font-72 as-roboto-slab as-font-w-700 as-text-download">
        {{ 'DOWNLOAD-APPS.download' | translate }}
      </p>
      <p class="as-font-medium as-font-20 as-font as-text-exp">
        {{ 'DOWNLOAD-APPS.exp' | translate }}
      </p>
      <div class="as-flex-direction as-justify-content">
        <div class="as-images-download-store">
          <a [href]="googlePlayUrl" target="_blank">
            <img
              width="215"
              height="64"
              class="as-pointer as-size-image-apps"
              ngSrc="assets/images/google-play.png"
            />
          </a>
        </div>
        <div
          class="as-images-download-store as-separation-image-download-banner-footer"
        >
          <a [href]="appStoreUrl" target="_blank">
            <img
              width="215"
              height="64"
              class="as-pointer as-size-image-apps"
              ngSrc="assets/images/app-store.png"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
  <app-home-footer> </app-home-footer>
</main>
